import { Component } from '@angular/core';
import { CalendlyService } from '../../modules/shared/services/calendly.service';

@Component({ standalone: false, 
  templateUrl: './trial-gate.component.html',
  styleUrls: ['./trial-gate.component.scss'],
})
export class TrialGateComponent {
  constructor(private calendlyService: CalendlyService) {}

  public talkToCyborg(): void {
    this.calendlyService.talkToCyborg();
  }
}
